// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ImageCropper.css */
.crop-container {
    position: relative;
    width: 500px;
    height: 500px;
    background-color: #333;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  
  .controls {
    display: flex;
    justify-content: space-between;
    margin-top: 10px;
  }
  
  button {
    position: relative;
    padding: 10px 20px;
    font-size: 16px;
    cursor: pointer;
  }
  
  .btn-primary {
    background-color: #007bff;
    color: white;
    border: none;
  }
  
  .btn-secondary {
    background-color: #6c757d;
    color: white;
    border: none;
  }
  .modal-header {
  position: absolute;
  top: 10px;
  right: 10px;
}

.btn-close {
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
}

  `, "",{"version":3,"sources":["webpack://./src/component/crop_image/ImageCropper.css"],"names":[],"mappings":"AAAA,qBAAqB;AACrB;IACI,kBAAkB;IAClB,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;EACzB;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,eAAe;EACjB;;EAEA;IACE,yBAAyB;IACzB,YAAY;IACZ,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,YAAY;IACZ,YAAY;EACd;EACA;EACA,kBAAkB;EAClB,SAAS;EACT,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;AACjB","sourcesContent":["/* ImageCropper.css */\r\n.crop-container {\r\n    position: relative;\r\n    width: 500px;\r\n    height: 500px;\r\n    background-color: #333;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n  }\r\n  \r\n  .controls {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    margin-top: 10px;\r\n  }\r\n  \r\n  button {\r\n    position: relative;\r\n    padding: 10px 20px;\r\n    font-size: 16px;\r\n    cursor: pointer;\r\n  }\r\n  \r\n  .btn-primary {\r\n    background-color: #007bff;\r\n    color: white;\r\n    border: none;\r\n  }\r\n  \r\n  .btn-secondary {\r\n    background-color: #6c757d;\r\n    color: white;\r\n    border: none;\r\n  }\r\n  .modal-header {\r\n  position: absolute;\r\n  top: 10px;\r\n  right: 10px;\r\n}\r\n\r\n.btn-close {\r\n  background: none;\r\n  border: none;\r\n  font-size: 24px;\r\n  cursor: pointer;\r\n}\r\n\r\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
